import styles from './IconAndHeading.module.css';

function IconAndHeading({ icon, heading, iconBackgroundColor, headingColor }) {
  return (
    <div
      className={styles.container}
      style={{
        '--icon-background-color': iconBackgroundColor,
        '--heading-color': headingColor,
      }}
    >
      <span className={styles.iconBackGround}>{icon}</span>
      <span className={styles.heading}>{heading}</span>
    </div>
  );
}

export default IconAndHeading;
